import * as React from "react";
import {ReactElement} from "react";
import {Button, SvgIcon} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {IFile} from "../../interfaces/files/IFile";

interface IProps {
    file: IFile
}

export default function DownloadButton({file}: IProps): ReactElement {
    const onDownload = (file: IFile) => {
        const link = document.createElement("a");
        link.download = file.name
        link.href = file.path;
        link.click();
    };

    return <Button
        aria-label="Download"
        key={file.name}
        onClick={() => onDownload(file)}
        variant="contained"
        color="primary"
    >
        <SvgIcon component={DownloadIcon} style={{paddingRight: 8}}/>
        {`${file.name} (${file.sizeText} MB)`}
    </Button>
}
